import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/login";
import MfaChallenge from "../pages/auth/mfa-challenge";
import CreateTenant from "../pages/auth/create-tenant";
import CRMConnections from "../pages/integration/integration";
import FacebookLogin from "../pages/integration/facebook";
import EcommerceIntegration from "../pages/integration/e-commerce";
import NextBestAction from "../pages/optimization/next-best-action";
import GeoLift from "../pages/measurement/geo-lift";
import BidOptimizer from "../pages/optimization/bid-optimizer";
import BidOptimizerDashboard from "../pages/optimization/bid-optimizer/id";
import MarketingMixModel from "../pages/measurement/marketing-mix-model";
import MMMDashboard from "../pages/measurement/marketing-mix-model/id";
import JobCreate from "../pages/job-create";
import DataSourceCreate from "../pages/data-source-create";
import Users from "../pages/users";
import Security from "../pages/security";
import CreateUser from "../pages/users/create-user";
import UpdateUser from "../pages/users/update-user"; 
import SyntheticControlLanding from "../pages/measurement/geo-lift/components/SyntheticControlLanding";
import mixpanel from "mixpanel-browser";
import { jwtDecode } from "jwt-decode";
import PrivateRoute from "./PrivateRoute";
import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard";
import GeoLiftStudy from "../pages/measurement/geo-lift/components/GeoLiftStudy";
import MMMLanding from "../pages/measurement/marketing-mix-model/components/MMMLanding";
import MainDashboard from "../components/MainDashboard";
import BidLanding from "../pages/optimization/bid-optimizer/BidLanding";
import CausalLoopLanding from "../pages/causal-loop/CausalLoopLanding";
import CausalLoopList from "../pages/causal-loop";
import CausalLoopRctLanding from "../pages/causal-loop-rct/CausalLoopRctLanding";
import CausalLoopRctList from "../pages/causal-loop-rct";
import ChatInterface from "../pages/chatBot/ChatInterface";
import Index from "../pages/MarketingLanding";
import PowerCalculatorLanding from "../pages/power-calculator/components/PowerCalculatorLanding";
import PowerCalculatorList from "../pages/power-calculator";
import PowerCalculatorStudy from "../pages/power-calculator/components/PowerCalculatorStudy";
import InsightsLanding from "../pages/chatBot/InsightsLanding";
import RctExperimentLanding from "../pages/rct-experiment/components/RctExperimentLanding";
import RctExperimentList from "../pages/rct-experiment";
import RctExperimentStudy from "../pages/rct-experiment/components/RctExperimentStudy";

mixpanel.init("590857ca7f2572c75c7f1c443e749dfc", {
  debug: true,
  track_pageview: true,
  persistence: "localStorage",
});

if (localStorage.getItem("authToken") != null) {
  const decoded = jwtDecode(localStorage.getItem("authToken") as string);
  mixpanel.identify(decoded.sub);
  mixpanel.people.set(decoded);
}

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/mfa-challenge" element={<MfaChallenge />} />
      <Route path="/landing" element={<Index />} />
      <Route element={<PrivateRoute />}>
        <Route path="/agent" element={<InsightsLanding />} />
        <Route path="/agent/:chatid" element={<ChatInterface />} />

        <Route path="/" element={<Dashboard />} />

        {/* Power Calculator Routes */}
        <Route
          path="/power-calculator/landing"
          element={<PowerCalculatorLanding />}
        />
        <Route
          path="/power-calculator/list"
          element={<PowerCalculatorList />}
        />
        <Route
          path="/power-calculator/:id"
          element={<PowerCalculatorStudy />}
        />
        {/* <Route path="/dashboard/dashboard" element={<Dashboard />} /> */}
        <Route path="/auth/create-tenant" element={<CreateTenant />} />
        <Route path="/crm/integrations" element={<CRMConnections />} />
        <Route path="/facebook/integrations" element={<FacebookLogin />} />
        <Route
          path="/e-commerce/integrations"
          element={<EcommerceIntegration />}
        />
        <Route
          path="/integrations/google-callback"
          element={<MainDashboard />}
        />
        <Route
          path="/optimization/next-best-action"
          element={<NextBestAction />}
        />

        <Route
          path="/measurement/geo-lift"
          Component={SyntheticControlLanding}
        />
        <Route
          path="/measurement/synthetic_control_list"
          element={<GeoLift />}
        />
        {/* <Route path="/measurement/geo-lift/:id" Component={GeoLiftDashboard} /> */}
        <Route path="/measurement/geo-lift/:id" Component={GeoLiftStudy} />

        {/* RCT Experiment Routes */}
        <Route path="/rct-experiment/landing" element={<RctExperimentLanding />} />
        <Route path="/rct-experiment/list" element={<RctExperimentList />} />
        <Route path="/rct-experiment/:id" element={<RctExperimentStudy />} />

        <Route path="/optimization/landing" element={<BidLanding />} />

        {/* Causal Loop Routes */}
        <Route path="/causal-loop/landing" element={<CausalLoopLanding />} />
        <Route path="/causal-loop/list" element={<CausalLoopList />} />
        <Route path="/causal-loop-rct/landing" element={<CausalLoopRctLanding />} />
        <Route path="/causal-loop-rct/list" element={<CausalLoopRctList />} />
        <Route path="/optimization/bid-optimizer" element={<BidOptimizer />} />
        <Route
          path="/optimization/bid-optimizer/:id"
          Component={BidOptimizerDashboard}
        />
        <Route
          path="/planning/marketing-mix-model"
          element={<MarketingMixModel />}
        />
        <Route
          path="/planning/marketing-mix-model-landing"
          element={<MMMLanding />}
        />

        {/* <Route path="/auth/hubspot/callback" Component={HubSpotOAuthCallback} /> */}
        <Route
          path="/planning/marketing-mix-model/:id"
          Component={MMMDashboard}
        />
        
        <Route path="/jobs/:jobType" element={<JobCreate />} />
        <Route
          path="/integrations/create/:dataSourceTypes"
          element={<DataSourceCreate />}
        />

        <Route path="/users" element={<Users />} />
        <Route path="/users/create-user" element={<CreateUser />} />
        <Route path="/users/update-user/:userId" element={<UpdateUser />} />

        <Route path="/security" element={<Security />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
